<template>
  <div id="course-title2">
    <h4 v-if="showTitle != 0" :title="title">
      {{ title }}
    </h4>
    <div style="overflow: hidden">
      <span
        @click="openDirec"
        :class="{ open: btnStatus }"
        class="introduction-btn"
        >{{$t('introduction')}}</span
      >
      <span
        v-if="showCourseInfo && showPdfList"
        @click="openCourseInfo"
        :class="{ open: coursebtnStatus }"
        class="introduction-btn course"
        >课程资料</span
      >
      <span class="hint-text">
        {{$t('progress')}}
        <template v-if="progressNumber == 0"
          ><i style="color: #005587">{{ progressNumber }}%</i></template
        >
        <template v-else
          ><i>{{ progressNumber }}%</i></template
        >
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: this.courseTitle,
      showTitle: this.$global_config.title,
      showCourseInfo: this.showCourse,
      showPdfList: true
    }
  },
  props: ['courseTitle', 'courseDirec', 'showCourse'],
  computed: {
    btnStatus () {
      return this.$store.state.courseAlertStatus
    },
    coursebtnStatus() {
      return this.$store.state.courseInfoAlertStatus;
    },
    // 学习小节进度
    progressNumber () {
      return Math.round(this.$store.state.studyProgress * 100)
    }
  },
  created () {
    this.showPdfList = this.data.materials && this.data.materials.length > 0 && this.$global_config.course_info.default
  },
  methods: {
    openDirec () {
      let btnStatus = this.btnStatus
      // this.btnStatus = !this.btnStatus  // 简介按钮样式改变
      this.$store.commit('courseAlertStatus', !btnStatus)  // 弹窗白色显示隐藏
      this.$store.commit('showPubAlertBg', !btnStatus)     // 弹窗灰色背景显示隐藏
    },
    openCourseInfo() {
      let btnStatus = this.coursebtnStatus
      // this.btnStatus = !this.btnStatus  // 简介按钮样式改变
      this.$store.commit('courseInfoAlertStatus', !btnStatus)  // 弹窗白色显示隐藏
      this.$store.commit('showPubAlertBg', !btnStatus)     // 弹窗灰色背景显示隐藏
    }
  }

}
</script>
<style lang="less" scoped>
#course-title2 {
  background: #eeeeee;
  padding: 15px 15px 15px 22px;
  h4 {
    color: #252631;
    font-size: 20px;
    font-weight: bold;
    height: 26px;
    margin-bottom: 15px;
    white-space: nowrap; /* 规定文本是否折行 */
    overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
  }
  .introduction-btn {
    position: relative;
    float: left;
    cursor: pointer;
    height: 18px;
    line-height: 18px;
    padding: 0 14px;
    background: #fff;
    color: #005587;
    border-radius: 26px;
    z-index: 20;
    min-width: 32px;
    border: 1px solid #005587;
    font-size: 14px;

    &.open {
      color: #ffffff;
      background: #005587;
      z-index: 21;
    }

    &.course{
      margin-left: 10px;
    }
  }
  .hint-text {
    float: right;
    font-size: 13px;
    color: #666666;
    i {
      color: #005587;
    }
  }
}
</style>
